export const STRAPI_URL = "https://accessible-growth-c3f18958d9.strapiapp.com";

const fetchAPI = async (url, options = {}) => {
  const {
    fallback = null,
    errorMessage = "Veri alınamadı",
    log = true,
  } = options;

  try {
    const res = await fetch(url);

    if (!res.ok) {
      let errorDetail = "";

      try {
        const errorData = await res.json();
        errorDetail =
          errorData?.error?.message ||
          errorData?.message ||
          `HTTP ${res.status}`;
      } catch {
        errorDetail = `HTTP ${res.status}`;
      }

      throw new Error(`${errorMessage}: ${errorDetail}`);
    }

    let data;
    try {
      data = await res.json();
    } catch {
      throw new Error(`${errorMessage}: JSON parse hatası`);
    }

    return data;
  } catch (error) {
    if (log) {
      console.error(`[API ERROR] ${errorMessage}`, {
        url,
        message: error.message,
      });
    }
    return fallback;
  }
};

export const getHeader = async () => {
  const data = await fetchAPI(
    `${STRAPI_URL}/api/headers?populate[logo]=true&populate[dil]=true`,
    {
      fallback: null,
      errorMessage: "Header verisi çekilemedi",
    }
  );

  return data?.data?.[0] ?? null;
};

export const getBanner = async () => {
  const data = await fetchAPI(`${STRAPI_URL}/api/banners?populate=*`, {
    fallback: null,
    errorMessage: "Banner verisi çekilemedi",
  });

  return data?.data?.[0] ?? null;
};

export const getOzellikler = async () => {
  const data = await fetchAPI(
    `${STRAPI_URL}/api/ozelliklers?populate=gorsel&sort=order:asc`,
    {
      fallback: [],
      errorMessage: "Özellikler verisi çekilemedi",
    }
  );

  return data?.data ?? [];
};

export const getFooter = async () => {
  const data = await fetchAPI(`${STRAPI_URL}/api/footers?populate=*`, {
    fallback: [],
    errorMessage: "Footer verisi çekilemedi",
  });

  return data?.data ?? [];
};

export const getHomeData = async () => {
  const data = await fetchAPI(
    `${STRAPI_URL}/api/home?populate[pageContent][on][sections.hero][populate]=*&populate[pageContent][on][sections.features-section][populate][cards][populate]=*&populate[pageContent][on][sections.grid-section][populate][features][populate]=*&populate[pageContent][on][sections.module-section][populate][modules][populate]=*&populate[pageContent][on][sections.feature-showcase][populate][items][populate]=*`,
    {
      fallback: null,
      errorMessage: "Home verisi çekilemedi",
    }
    
  );
  return data?.data ?? null;
};

export const getHizmetlerPage = async () => {
  const data = await fetchAPI(
    `${STRAPI_URL}/api/hizmetler?populate[pageContent][populate]=*`,
    {
      fallback: null,
      errorMessage: "Hizmetler sayfası verisi çekilemedi",
    }
  );

  return data?.data ?? null;
};

export const getPersonelPage = async () => {
  const data = await fetchAPI(
    `${STRAPI_URL}/api/personel?populate[pageContent][populate]=*`,
    {
      fallback: null,
      errorMessage: "Personel sayfası verisi çekilemedi",
    }
  );

  return data?.data ?? null;
};

export const getBelgelerPage = async () => {
  const data = await fetchAPI(
    `${STRAPI_URL}/api/belgeler?populate[pageContent][on][sections.hero][populate]=image&populate[pageContent][on][sections.features-section][populate]=cards&populate[pageContent][on][sections.module-section][populate][modules][populate]=image&populate[pageContent][on][sections.cta][populate]=*`,
    {
      fallback: null,
      errorMessage: "Belgeler sayfası verisi çekilemedi",
    }
  );

  return data?.data ?? null;
};

export const getTesislerPage = async () => {
  const data = await fetchAPI(
    `${STRAPI_URL}/api/tesisler?populate[pageContent][populate]=*`,
    {
      fallback: null,
      errorMessage: "Tesisler sayfası verisi çekilemedi",
    }
  );
  return data?.data ?? null;
};

export const getDonanimPage = async () => {
  const data = await fetchAPI(
    `${STRAPI_URL}/api/donanim?populate[pageContent][on][sections.features-section][populate][cards][populate]=*&populate[pageContent][on][sections.hero][populate]=*&populate[pageContent][on][sections.stats-section][populate][stats][populate]=*&populate[pageContent][on][sections.grid-section][populate][features][populate]=*&populate[pageContent][on][sections.grid-section][populate][image][populate]=*`,
    {
      fallback: null,
      errorMessage: "Donanım sayfası verisi çekilemedi",
    }
  );
  return data?.data ?? null;
};

export const getFizikselMedyaPage = async () => {
  const data = await fetchAPI(
    `${STRAPI_URL}/api/fiziksel-medya?populate[pageContent][populate]=*`,
    {
      fallback: null,
      errorMessage: "Fiziksel Medya sayfası verisi çekilemedi",
    }
  );

  return data?.data ?? null;
};

export const getVeriPage = async () => {
  const data = await fetchAPI(
    `${STRAPI_URL}/api/veri?populate[pageContent][populate]=*`,
    {
      fallback: null,
      errorMessage: "Veri sayfası verisi çekilemedi",
    }
  );

  return data?.data ?? null;
};

export const getAgCihazlariPage = async () => {
  const data = await fetchAPI(
    `${STRAPI_URL}/api/ag-cihazlari?populate[pageContent][populate]=*`,
    {
      fallback: null,
      errorMessage: "Ağ Cihazları sayfası verisi çekilemedi",
    }
  );

  return data?.data ?? null;
};

export const getNedenBizPage = async () => {
  const data = await fetchAPI(
    `${STRAPI_URL}/api/neden-biz?populate[pageContent][populate]=*`,
    {
      fallback: null,
      errorMessage: "Neden Biz sayfası verisi çekilemedi",
    }
  );

  return data?.data ?? null;
};

export const getYazilimPage = async () => {
  const data = await fetchAPI(
    `${STRAPI_URL}/api/yazilim?populate[pageContent][populate]=*`,
    {
      fallback: null,
      errorMessage: "Yazılım sayfası verisi çekilemedi",
    }
  );
  return data?.data ?? null;
};

export const getFiyatlandirmaPage = async () => {
  const data = await fetchAPI(
    `${STRAPI_URL}/api/fiyatlandirma?populate[pageContent][on][sections.pricing-section][populate][plans][populate]=features&populate[pageContent][on][sections.comparison-section][populate]=rows&populate[pageContent][on][sections.faq-section][populate]=items&populate[pageContent][on][sections.hero][populate]=*&populate[pageContent][on][sections.cta][populate]=*`,
    {
      fallback: null,
      errorMessage: "Fiyatlandırma sayfası verisi çekilemedi",
    }
  );

  return data?.data ?? null;
};

export const getIletisimPage = async () => {
  const data = await fetchAPI(
    `${STRAPI_URL}/api/iletisim?populate[pageContent][populate]=*`,
    {
      fallback: null,
      errorMessage: "İletişim sayfası verisi çekilemedi",
    }
  );

  return data?.data ?? null;
};

export const getIso27001 = async () => {
  const data = await fetchAPI(
    `${STRAPI_URL}/api/iso27001?` +
    `populate[pageContent][on][sections.hero][populate]=*` +
    `&populate[pageContent][on][sections.features-section][populate][cards][populate]=*` +
    `&populate[pageContent][on][sections.risk-steps-section][populate][steps]=*` +
    `&populate[pageContent][on][sections.risk-steps-section][populate][panelItems]=*` +
    `&populate[pageContent][on][sections.annex-section][populate][groups][populate][examples]=*` +
    `&populate[pageContent][on][sections.annex-section][populate][newControls]=*` +
    `&populate[pageContent][on][sections.steps-section][populate][steps]=*` +
    `&populate[pageContent][on][sections.pdca-section][populate][steps]=*` +
    `&populate[pageContent][on][sections.audit-section][populate][cards]=*` +
    `&populate[pageContent][on][sections.audit-section][populate][failureSteps]=*` +
    `&populate[pageContent][on][sections.sectors-section][populate][sectors]=*` +
    `&populate[pageContent][on][sections.cost-section][populate][items][populate][items]=*` +
    `&populate[pageContent][on][sections.faq-section][populate][items]=*` +
    `&populate[pageContent][on][sections.cta][populate]=*`,
    {
      fallback: null,
      errorMessage: "ISO27001 verisi çekilemedi",
    }
  );

  return data?.data ?? null;
};

export const getPartners = async () => {
  const data = await fetchAPI(
    `${STRAPI_URL}/api/partners?populate=*&sort=sira:asc`,
    {
      fallback: [],
      errorMessage: "Partner verisi çekilemedi",
    }
  );

  return data?.data ?? [];
};

export const getHeaderData = async () => {
  const data = await fetchAPI(`${STRAPI_URL}/api/headder?populate=*`, {
    fallback: null,
    errorMessage: "Header çekilemedi",
  });

  return data?.data ?? null;
};